'use strict'

const RADIO_CELL_DATA = {
  YES: 'Yes',
  NO: 'No'
}

const DIVISION_DISPLAY_DATA = {
  I: 'I',
  II: 'II',
  III: 'III'
}

const SUBDIVISION_DISPLAY_DATA = {
  FBS: 'FBS',
  FCS: 'FCS',
  I: 'I'
}

const GENDER_DISPLAY_DATA = {
  MALE: 'Male',
  FEMALE: 'Female'
}

const PRIVATE_FLAG_DATA = {
  PUBLIC: 'Public',
  PRIVATE: 'Private'
}

function renderYesNoText (data) {
  if (data === 'Y') {
    return RADIO_CELL_DATA.YES
  }
  return RADIO_CELL_DATA.NO
}

function renderYesNoBoolean (data) {
  if (data) {
    return RADIO_CELL_DATA.YES
  }
  return RADIO_CELL_DATA.NO
}

function renderDivisionText (data) {
  if (data === 1) {
    return DIVISION_DISPLAY_DATA.I
  } else if (data === 2) {
    return DIVISION_DISPLAY_DATA.II
  } else if (data === 3) {
    return DIVISION_DISPLAY_DATA.III
  } else {
    return ''
  }
}

function renderSubdivisionText (data) {
  if (data === 1) {
    return SUBDIVISION_DISPLAY_DATA.FBS
  } else if (data === 2) {
    return SUBDIVISION_DISPLAY_DATA.FCS
  } else if (data === 3) {
    return SUBDIVISION_DISPLAY_DATA.I
  } else {
    return ''
  }
}

function renderDivisionSubdivisionText (division, subdivision) {
  let display = ''
  if (division === 1) {
    display = DIVISION_DISPLAY_DATA.I
    if (subdivision === 1) {
      display += '-' + SUBDIVISION_DISPLAY_DATA.FBS
    } else if (subdivision === 2) {
      display += '-' + SUBDIVISION_DISPLAY_DATA.FCS
    }
  } else if (division === 2) {
    display = DIVISION_DISPLAY_DATA.II
  } else if (division === 3) {
    display = DIVISION_DISPLAY_DATA.III
  }
  return display
}

function renderHyperlink (url, icon) {
  let hyperlink = '<a href="http://' + url + '" target="_blank" >'
  if (icon && icon.length > 0) {
    hyperlink += '<span class="glyphicons ' + icon + '"></span>'
  }
  hyperlink += url + '</a>'
  return hyperlink
}

function renderHyperlinkWithText (url, text, newTab) {
  let hyperlink = '<a href="' + url + '"'

  if (newTab) {
    hyperlink += ' target="_blank"'
  }
  hyperlink += '>'

  hyperlink += text + '</a>'
  return hyperlink
}

function renderDateTime (date) {
  return date.toLocaleDateString()
}

function renderInitCap (data) {
  let result = ''

  if (data) {
    let array = data.split(' ')

    for (let i = 0; i < array.length; i++) {
      if (i > 0) {
        result = result + ' '
      }

      result = result + capitalize(array[i].toLowerCase())
    }
  }

  return result
}

function capitalize (data) {
  return data.charAt(0).toUpperCase() + data.slice(1)
}

function renderGenderText (data) {
  if (data === 'M') {
    return GENDER_DISPLAY_DATA.MALE
  } else if (data === 'F') {
    return GENDER_DISPLAY_DATA.FEMALE
  } else {
    return ''
  }
}

function renderPrivateFlagText (data) {
  if (data === 'Y') {
    return PRIVATE_FLAG_DATA.PRIVATE
  } else {
    return PRIVATE_FLAG_DATA.PUBLIC
  }
}

export default {
  renderYesNoText: renderYesNoText,
  renderDivisionText: renderDivisionText,
  renderSubdivisionText: renderSubdivisionText,
  renderDivisionSubdivisionText: renderDivisionSubdivisionText,
  renderHyperlink: renderHyperlink,
  renderHyperlinkWithText: renderHyperlinkWithText,
  renderInitCap: renderInitCap,
  renderDateTime: renderDateTime,
  renderGenderText: renderGenderText,
  renderYesNoBoolean: renderYesNoBoolean,
  renderPrivateFlagText: renderPrivateFlagText
}



// WEBPACK FOOTER //
// ./src/js/common/DataTableHelper.js